import { isTruthy } from 'corso-types';
import { z } from 'zod';
import { customerInfoSchema } from '~/utils/schemas';
import { PartialDeep } from '~/utils/types';

type CustomerInfo = PartialDeep<z.infer<typeof customerInfoSchema>>;

export default function CustomerInfoDisplay({
  info: { email, firstName, lastName, address },
}: {
  info: CustomerInfo;
}) {
  const region = [address?.stateOrProvinceCode, address?.postalCode]
    .filter(isTruthy)
    .join(' ');
  const locality = [address?.city, region].filter(isTruthy).join(', ');

  return (
    <address className="italic" aria-label="Address">
      {(firstName || lastName) && (
        <>
          <span>
            {firstName} {lastName}
          </span>
          <br />
        </>
      )}
      {email && (
        <>
          <span>{email}</span>
          <br />
        </>
      )}
      <span>{address?.line1}</span>
      <br />
      {address?.line2 && (
        <>
          {address.line2}
          <br />
        </>
      )}
      {locality && (
        <>
          <span>{locality}</span>
          <br />
        </>
      )}
      <span>{address?.countryCode}</span>
      <br />
      {address?.phone && <span>{address.phone}</span>}
    </address>
  );
}
